import { render, staticRenderFns } from "./OtherProduct.vue?vue&type=template&id=98ae1b9c&scoped=true&"
import script from "./OtherProduct.vue?vue&type=script&lang=js&"
export * from "./OtherProduct.vue?vue&type=script&lang=js&"
import style0 from "./OtherProduct.vue?vue&type=style&index=0&lang=css&"
import style1 from "./OtherProduct.vue?vue&type=style&index=1&id=98ae1b9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98ae1b9c",
  null
  
)

export default component.exports